import { createContext } from 'react';

import type { UseEditPersonaFormReturn } from '../hooks/useEditPersonaForm/useEditPersonaForm';

export const FormContext = createContext<UseEditPersonaFormReturn | null>(null);
